import { render, staticRenderFns } from "./submitted-successfully.vue?vue&type=template&id=e522c54e"
import script from "./submitted-successfully.vue?vue&type=script&lang=js"
export * from "./submitted-successfully.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports